module.exports = __webpack_public_path__ + "img/tooth-missing.94f31a72.png";